import { SaveUserActivitiesMark, SaveUserListMap, StateLogbook } from "../types";

export const userListMap = (state: StateLogbook, action: SaveUserListMap): StateLogbook => {
    const { activityRegister } = state
    const { activity, allSelecteds, usersChecks } = activityRegister
    return {
        ...state,
        activityRegister: {
            ...activityRegister,
            activity: { ...activity, ...action, total: action.totalPage },
            ...!allSelecteds && { usersUnChecks: action.userList.filter(user => !usersChecks.some(check => check == user.id)).map(user => user.id) },
            ...!!allSelecteds && { usersChecks: action.userList.map(user => user.id) },
        }
    }
}

export const saveUserActivitiesMark = (state: StateLogbook, action: SaveUserActivitiesMark): StateLogbook => {
    const { activityRegister, myActivity } = state
    const { activity } = activityRegister
    return {
        ...state,
        ...!action.myActivity && { activityRegister: { ...activityRegister, activity: { ...activity, usersMark: action.value, total: action.totalPage ?? 0 }, } },
        ...!!action.myActivity && { myActivity: { ...myActivity, usersMark: action.value, total: action.totalPage ?? 0 } }
    }
}